import { useStorage } from '@vueuse/core'
import { Country, CountryCode, CurrencySymbols } from '~/types/countries'
import { PartnerTiersResponse } from '~/types/partners'

export function useWorkspace() {
  const api = useHttpClient()
  const user = useUserStore()
  const { startBarLoad, endBarLoad } = useAppStore()
  const countryCodeList = Object.keys(CountryCode)
  const initialCountries: Country[] = []
  const countries = ref(useStorage('countries', initialCountries))
  const partnerTiers = ref<PartnerTiersResponse[]>([])

  /* Setup */
  async function setup(accessToken: string, refreshToken: string) {
    user.setTokens(accessToken, refreshToken)
    user.checkForAdminId(accessToken)

    const userData = await api.users.getMe()
    user.setMyData(userData)
    fetchCountries()
  }

  /* Countries */
  async function fetchCountries() {
    try {
      const data = await api.countries.get()
      countries.value = data
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchPartnerTiers() {
    try {
      startBarLoad()
      const data = await api.partners.getPartnerTiers()
      partnerTiers.value = data
    } catch (error) {
      console.log(error)
    } finally {
      endBarLoad()
    }
  }

  function getCountryInfo(targetCode: string) {
    if (!targetCode) return null
    const country = countries?.value?.find(
      (c: Country) => c.code === targetCode,
    )

    if (!country) return null
    const { region, phoneCode, currencyCode, code, serverLocation } = country
    return {
      region,
      code,
      phoneCode,
      currencyCode,
      currency: CurrencySymbols[currencyCode],
      serverLocation,
    }
  }

  return {
    countryCodeList,
    getCountryInfo,
    fetchCountries,
    setup,
    countries,
    fetchPartnerTiers,
    partnerTiers,
  }
}
